export function localDateToString(date) {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  return `${year}-${month}-${day}`;
}

export function localDateFromString(dateString) {
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
}

export function dateRangeToPrettyString(startDate, endDate) {
  const startStr = startDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  const endStr = endDate.toLocaleDateString('en-US', { month: (startDate.getMonth() === endDate.getMonth() ? undefined : 'short'), day: 'numeric' });
  return `${startStr} - ${endStr}`;
}

export function getFirstDayOfMonth(date = new Date()) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

// Week start day values follow JavaScript Date.getDay() convention:
// 0 = Sunday, 1 = Monday, 2 = Tuesday, 3 = Wednesday, 4 = Thursday, 5 = Friday, 6 = Saturday
// Default is 1 (Monday)
export function getStartOfWeek(date = new Date(), weekStartDay = 1) {
  const day = date.getDay();
  const diff = date.getDate() - day + (day < weekStartDay ? weekStartDay - 7 : weekStartDay);
  const startOfWeek = new Date(date);
  startOfWeek.setDate(diff);
  startOfWeek.setHours(0, 0, 0, 0);
  return startOfWeek;
}

// Helper function that always uses Monday (1) as week start
export function getMondayOfWeek(date = new Date()) {
  return getStartOfWeek(date, 1);
}

// weekStartDay: 0=Sunday, 1=Monday, ..., 6=Saturday (default: 1=Monday)
export function getEndOfWeek(currentWeekStart) {
  const endOfWeek = new Date(currentWeekStart.getTime());
  endOfWeek.setDate(endOfWeek.getDate() + 6);
  endOfWeek.setHours(23, 59, 59, 999);
  return endOfWeek;
}

// Describes weekStart relative to the week containing "now" -- "Current week",
// "Next week", "Last week", "In N weeks", "N weeks ago".
export function relativeWeekLabel(weekStart, weekStartDay = 1) {
  const thisWeekStart = getStartOfWeek(new Date(), weekStartDay);
  const diffDays = Math.round((weekStart.getTime() - thisWeekStart.getTime()) / (24 * 60 * 60 * 1000));
  const diffWeeks = Math.round(diffDays / 7);

  if (diffWeeks === 0) return 'Current week';
  if (diffWeeks === 1) return 'Next week';
  if (diffWeeks === -1) return 'Last week';
  if (diffWeeks > 1) return `In ${diffWeeks} weeks`;
  return `${Math.abs(diffWeeks)} weeks ago`;
}

export function getWeekDays(weekStart) {
  const days = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(weekStart);
    date.setDate(weekStart.getDate() + i);
    days.push(date);
  }
  return days;
}

export function secondsToTime(seconds) {
  const remainingSeconds = Math.floor(seconds % 60);
  const minutes = Math.floor(seconds / 60);
  const remainingHours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  if (remainingHours > 0) {
    return `${remainingHours}:${pad(remainingMinutes)}:${pad(remainingSeconds)}`;
  }

  return `${remainingMinutes}:${pad(remainingSeconds)}`;
}

function pad(val) {
  return String(val).padStart(2, '0');
}
